<script lang="ts">
    import { twMerge } from 'tailwind-merge';
    import { iconClasses } from './icon-settings';
    import { draw } from 'svelte/transition';

    let className = '';
    export { className as class };
</script>

<svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class={twMerge(iconClasses, className)}
    {...$$restProps}>
    <path d="M21.801 10A10 10 0 1 1 17 3.335" in:draw />
    <path d="m9 11 3 3L22 4" in:draw />
</svg>
